// extracted by mini-css-extract-plugin
module.exports = {"input":"_1tIvXF8Dj8Er"};